module.exports = __webpack_public_path__ + "static/media/1.bbeb8aa2.png";